import { render, staticRenderFns } from "./MultipleMRNIcon.vue?vue&type=template&id=c5593aca&scoped=true&"
import script from "./MultipleMRNIcon.vue?vue&type=script&lang=js&"
export * from "./MultipleMRNIcon.vue?vue&type=script&lang=js&"
import style0 from "./MultipleMRNIcon.vue?vue&type=style&index=0&id=c5593aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5593aca",
  null
  
)

export default component.exports